// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"d2-z","colorTextValue":"e2-z","swatches":"f2-z","collapseLink":"g2-z","isCollapsed":"h2-z","dropdown":"i2-z","disabled":"j2-z"};